import React from 'react';
import { I18n } from 'react-redux-i18n';
import { Lock01 } from '@untitledui/icons';

import { I18N_BASE } from '../../constants';
import { formatAge } from '../../helpers/formatAge';
import styles from './LockedByBadge.module.css';

export interface LockedByBadgeProps {
  reviewerName: string | null;
  lastHeartbeatAt: string | null;
  now?: number;
  testId?: string;
}

export function LockedByBadge({
  reviewerName,
  lastHeartbeatAt,
  now,
  testId,
}: LockedByBadgeProps): React.ReactElement {
  const displayName =
    reviewerName ?? I18n.t(`${I18N_BASE}.general.unknownReviewer`);
  const age = lastHeartbeatAt
    ? formatAge(lastHeartbeatAt, now ?? Date.now())
    : null;
  return (
    <span className={styles.badge} data-testid={testId}>
      <span className={styles.iconWrap} aria-hidden="true">
        <Lock01 width={14} height={14} />
      </span>
      <span className={styles.name}>{displayName}</span>
      {age ? (
        <span className={styles.age}>
          {I18n.t(age.i18nKey, { value: age.value })}
        </span>
      ) : null}
    </span>
  );
}

export default LockedByBadge;
